var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.977,
    height: 26.467,
    viewBox: "0 0 20.977 26.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M192.223,465.044a4,4,0,0,1-7.319,0Z",
    transform: "translate(-178.075 -440.965)",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M199.348,2.529a8.993,8.993,0,0,0-3.071.538V2.948A2.952,2.952,0,0,1,199.225,0h.244a2.952,2.952,0,0,1,2.948,2.948v.117A9.011,9.011,0,0,0,199.348,2.529Z",
    transform: "translate(-188.859 0)",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M53.811,97.28H73.193a.79.79,0,0,0,.779-.606.754.754,0,0,0-.415-.857,4.113,4.113,0,0,1-1.252-1.7,19.66,19.66,0,0,1-1.3-7.78,7.5,7.5,0,0,0-15-.03c0,.01,0,.02,0,.03a19.66,19.66,0,0,1-1.3,7.78,4.112,4.112,0,0,1-1.252,1.7.753.753,0,0,0-.415.857A.79.79,0,0,0,53.811,97.28Zm-.373-1.458h0Z",
    transform: "translate(-53.013 -74.754)",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.068e8633d26825f73f3f1bf1b96fd722.svg";
export { ForwardRef as ReactComponent };